/*global moment, wc_bookings_user_my_account_params*/

jQuery( document ).ready( function( $ ) {
	var localTimezone = moment.tz.guess();
	var shouldDisplayNotices = false;

	/**
	 * Callback that checks if we should add timezone string to the booking start and end time.
	 *
	 * Since admin does not know what timezone the user is in, it is not possible to set a proper
	 * local timezone for the booking manually create by admin. If timezone conversion is enabled
	 * and the user timezone is different then admin timezone the user will see wrong start and end times.
	 * Time conversion is not possible because at this stage we don't know what is the time format used.
	 * Adding timezone string and a notice should make things more clear.
	 *
	 * Reference: https://github.com/woocommerce/woocommerce-bookings/issues/2650
	 *
	 * @param {element index } index
	 * @param {jQuery element } element
	 */
	var maybeAddTimezone = function( index, element ) {
		var elementTimezone = $( element ).data( 'timezone' );

		if ( $( element ).data( 'all-day' ) === 'yes' ) {
			// Don't adjust for day availability type events.
			return;
		}

		if ( elementTimezone !== localTimezone ) {
			$( element ).text( $( element ).text() + ' ' + elementTimezone );
			shouldDisplayNotices = true;
		}
	};

	if ( ! wc_bookings_user_my_account_params.timezone_conversion ) {
		// No conversion necessary, don't adjust the time display.
		return;
	}

	if ( ! localTimezone ) {
		// Local timezone not found. We can't compare the bookings timezone to local - abort!
		return;
	}

	$( '.my_account_bookings' )
		.find( 'tbody .booking-start-date' )
		.each( maybeAddTimezone );

	$( '.my_account_bookings' )
		.find( 'tbody .booking-end-date' )
		.each( maybeAddTimezone );

	// Inform user about the display of timezones for some of the items.
	if ( shouldDisplayNotices ) {
		$( '.bookings-my-account-notice' )
			.text( wc_bookings_user_my_account_params.timezone_notice + ' ' + localTimezone + '.' )
			.show();
	}

} );
